module.exports = "\n<time [dateTime]=\"appointment.availability.startTime\">{{ formattedDate }}</time>\n<patient-name *ngIf=\"patient\"\n  [name]=\"patient | displayName\"\n  [oldUi]=\"true\">\n</patient-name>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/main/appointments/appointment/appointment.component.html
// module id = 1243
// module chunks = 0